import { DocumentsImagesStoreAbstract } from '@shared/documents-images/DocumentsImagesStoreAbstract';
import { DocumentsService } from '@shared/documents/DocumentsService';

export class DocumentsStore extends DocumentsImagesStoreAbstract<IDocument> {
    type = 'documents' as const;
    loadedEvent: string = 'documents-loaded';

    constructor() {
        super();
        this.sortKey = 'name';
    }

    fetch = DocumentsService.fetchAll;

    downloadByIds = DocumentsService.download;

    removeByUuids = (uuids: string[]) => {
        if (!confirm(__('js_map.documents.delete_confirm'))) {
            return null;
        }
        const items = this.getByUuids(uuids);
        const idoc = items.filter(i => !i.url).map(i => i.id);
        const edoc = items.filter(i => !!i.url).map(i => i.id);
        return DocumentsService.remove(idoc, edoc);
    };

    onItemsLoaded = () => {};
}
